module.exports = __webpack_public_path__ + "36dfd5b7c4e941a69c9b0c25db832f84.png";